export enum TSOBarcodeMode {
  Css = 'css'
}
